(function() {
    'use strict';

    angular
        .module('elogbooks.user.quote-requests')
        .config(registerRoutes);

    function registerRoutes($stateProvider) {
        elbQuoteRequestRouting().addRoutes($stateProvider, 'dashboard.user.quote-requests', true);
    }
})();
